import React, { lazy } from 'react';
import SkeletonGrid from '../../../../skeleton_loaders/common/SkeletonGrid.jsx';
import withSuspense from '../../../../helpers/withSuspense.jsx';

const WidgetHeader = withSuspense(lazy(() => import('./WidgetHeader.jsx')), <SkeletonGrid />);

export default WidgetHeader;
